import Banner from "@/components/landing/howWorks/Banner";
import Faqs from "@/components/landing/howWorks/Faqs";
import HowItsWork from "@/components/landing/howWorks/HowItsWork";

export default function HowWorks() {
  return (
    <>
      {/* Banner section */}
      <Banner />

      {/* How Its Work section */}
      <HowItsWork />

      {/* Faqs section */}
      <Faqs />
    </>
  );
}
